app.service('ajaxOverwrite', function (modal, loading, console, front, cookie, nativeApp) {

	if (document.location.search && document.location.search.indexOf('ucm-scripts') > -1) {
		$.ajaxSetup({
			data: {
				'ucm-scripts': 'off'
			}
		});
		$().ready(function () {
			$("a[href*='.bhtml']").each(function (i, n) {
				var href = $(n).attr('href').replace('.bhtml?', '.bhtml&').replace('.bhtml', '.bhtml?ucm-scripts=off');
				$(n).attr('href', href);
			});
		})
	}
	let appToken;
	$().ready(function () {
		if(front.getParam('mobileApp')){

			nativeApp.setEventListener(function (eventDetail) {
				if (eventDetail?.type === 'CART_TOKEN_AVAILABLE') {
					appToken = eventDetail.token;
					$('form').each(function(i, n){
						$(this).find('input[name="X-App-Secret"]').remove();
						$(this).append('<input type="hidden" name="X-App-Secret" value="'+appToken+'"/>');
					});
				}
			});
			nativeApp.postMessage({ type: 'CART_TOKEN_CONSUMER_READY' });
		}
	});

	if (document.location.search && document.location.search.indexOf('ucm-scripts') > -1) {
		$.ajaxSetup({
			data: {
				'ucm-scripts': 'off'
			}
		});
	}
	if (document.location.search && document.location.search.indexOf('ucm-cache') > -1) {
		$.ajaxSetup({
			data: {
				'ucm-cache': 'off'
			}
		});
	}
	$(document).on('ajaxSuccess', function (event, jqXHR, settings) {
		console.log('Sukces: ' + settings.url)
	})
	$(document).on('ajaxError', function (event, jqXHR, settings, thrownError) {
		if (thrownError !== "abort" && settings.url.indexOf('/shopEvent.ltr') == -1 && (settings.url.indexOf('.ltr') > -1 || settings.url.indexOf('.bhtml') > -1)) {
			app.logEvent({
				id: 'error-ajax',
				f03: settings.url.indexOf('?') > -1 ? settings.url.substr(0, settings.url.indexOf('?')) : settings.url,
				f04: front.page(),
				f05: cookie.get('JSESSIONID')
			});
			UA.interaction('Monitoring', 'Błąd ajaxa', document.location.href);
		}
		console.log('Błąd ajaxa: ' + settings.url, jqXHR, thrownError);

		var statusCode = jqXHR.status;
		var header = jqXHR.getResponseHeader('CSRF_ERROR');
		var backend = jqXHR.getResponseHeader('x-backend');

		if (header) {
			if (statusCode === 403) {
				modal.alert("Wystąpił błąd, spróbuj ponownie później.", function () {
					loading.reload({ soft: true });
				});
			} else if (statusCode === 401) {
				modal.alert("Zostałeś wylogowany, zaloguj się ponownie.", function () {
					loading.reload({ soft: true });
				});
			}
		} else {
			if ((statusCode === 403 || statusCode === 401) && settings.url.indexOf('customer_j_spring_security_check.ltr') == -1 && settings.url.indexOf('/shopEvent.ltr') == -1) {
				if (backend) {
					modal.alert("Twoja sesja wygasła. Prosimy zalogować się ponownie.", function () {
						loading.reload({ soft: false });
					});
				} else {
					console.info('Zablokowane żądanie');
				}
			}
		}
	});
	var token;
	var header;
	$.ajaxSetup({
		beforeSend: function (request, settings) {
			if(appToken && front.getParam('mobileApp')){
				request.setRequestHeader('X-App-Secret', appToken);
			}
			var $meta;
			if (!token && !header) {
				$meta = $("meta[name='_csrf']");
				if ($meta.length) {
					token = $meta.attr("content");
					$meta = $("meta[name='_csrf_header']");
					header = $meta.attr("content");
				}
			}
			if (token && header) {
				request.setRequestHeader(header, token);
			} else {
				var $input = $("input[name='_csrf']:last");
				if ($input.length) {
					request.setRequestHeader('X-CSRF-TOKEN', $input.val());
				}
			}
			if (settings && settings.url) {
				console.log('Wysyłanie ajaxa: ' + settings.url);
			}
		}
	});
});
